import axios from "axios";
import { useMemo } from "react";
import { useAuth } from "@clerk/react";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const publicApi = axios.create({ baseURL: API });

export const getCompany = () => localStorage.getItem("mcai_company") || "";
export const getOrg = () => localStorage.getItem("mcai_org") || "";

export function useApi() {
  const { getToken } = useAuth();
  return useMemo(() => {
    const inst = axios.create({ baseURL: API });
    inst.interceptors.request.use(async (cfg) => {
      const t = await getToken();
      if (t) cfg.headers.Authorization = `Bearer ${t}`;
      if (getCompany()) cfg.headers["X-Company-Id"] = getCompany();
      if (getOrg()) cfg.headers["X-Org-Id"] = getOrg();
      return cfg;
    });
    inst.token = getToken;
    return inst;
  }, [getToken]);
}

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => `${x.loc?.slice(-1)[0] || ""}: ${x.msg}`).join("; ");
  return d || "Não foi possível concluir. Verifique sua conexão e tente novamente.";
};
